import InvoiceForm from "./InvoiceForm";

export default function PaymentVerificationForm() {
  return <InvoiceForm variant="verification" />;
}
